import Vue from 'vue';
import modal from './modal';

let instance;

const fnTypes = ['show'];

const ModalConstruct = Vue.extend(modal);

const Modal = function(options = {}) {
  if (!instance) {
    instance = new ModalConstruct({
      data: options
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
  } else {
    Object.assign(instance.$data, options);
  }
  return instance;
};

fnTypes.forEach(type => {
  Modal[type] = options => Modal(options).openDownload();
});

Modal.hide = () => {
  instance && instance.close();
};

Modal.destroy = () => {
  instance && instance.destroy();
};

export default Modal;
